import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/multi_step/workflow_overview_board_actions'

export default createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      Object.assign(state, action.data)
    })
    .addCase(types.SELECT_FILTER_OPTION, (state, action) => {
      const { opts, filterType } = action
      const selectedIds = opts.map(opt => opt.value)
      
      if (state.filtersData && state.filtersData[filterType]) {
        state.filtersData[filterType].forEach(item => {
          item.selected = selectedIds.includes(item.value)
        })
      }
    })
})